export default "__VITE_PUBLIC_ASSET__06f8d7f9__"